import React from "react" ;
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Globals } from "root/DataFunctions/BaseDataFns";
import {getDocumentUrl, getUserImageUrl} from "root/DataFunctions/CommonDataFns";
import {IconPath, PostStatus, UserTypeName} from "root/DataFunctions/Constants";

const ChildPost = (props) => {
    const {post, setIndexFromPost, postIndex} = props;
    const postImageUrl = getDocumentUrl(post.image_array[0], 200, true, post.document_array[0]);
    const senderAvatarImageUrl = Globals.APIFolder + '/user/' + post.sender_user_id + '/avatar?thumb&size=100'
    const calendar = Globals.BaseURL + "/images/icons/child/calendar.png";
    const countDownIconUrl = Globals.BaseURL + "/images/icons/child/countdown.png";
    const moveIconUrl = Globals.BaseURL + "/images/icons/child/move.png";
    const editIconUrl = Globals.BaseURL + "/images/icons/child/edit-text.png";
    const docUrl = Globals.BaseURL + "/images/icons/child/document.png";
    const deleteIconUrl = Globals.BaseURL + IconPath.ICON_MESSAGE_DELETE;

    const isFromMe = post.unenc_recipient_user_id === post.unenc_sender_user_id ? true : false;

    const getDocUrl = (  ) =>
    {
        return  '/getFile.php?enc_docid=' + post.document_array[0];
    }

    const getPostUserImageUrl = (  ) =>
    {
        const userImage = post.typeName === UserTypeName.BIRTH_PARENT ? null : post.user_image;

        return getUserImageUrl(userImage, 50, true);
    }

    const canMoveToDraft = + post.status === PostStatus.NEW || isFromMe;

    const getFromNameToDisplay = (  ) =>
    {
        //If posted_by_name set display this, else display firstname only
        if( isFromMe){
            name = 'Me'
        }
        else if(post.posted_by_name !== null && post.posted_by_name !== ''){
            name = post.posted_by_name;
        }
        else{
            name = post.firstname;
        }

        return name
    }

    const getToNameToDisplay = (  ) =>
    {
        //If posted_by_name set display this, else display firstname only
        if( isFromMe){
            name = 'Me'
        }
        else if(post.known_as !== null && post.known_as !== ''){
            name = post.known_as;
        }
        else{
            name = post.to_name.split(' ')[0];
        }

        return name
    }

    const publishedInfoMeta = () => {
        return(
            // Only show if the post is to themselves or the post is unapproved
            <div>
                { canMoveToDraft &&
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip id="tooltip-right">
                                Move to drafts
                            </Tooltip>
                        }
                    >
                        <button
                            className="child_icon_button pubDraftControls"
                            onClick={() => props.moveToDrafts(post.post_id)}
                        >
                            <img className="icn" src={moveIconUrl} alt="Move to draft"/>
                        </button>
                    </OverlayTrigger>
                }
            </div>
        )
    }

    const draftInfoMeta = () => {
        return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip id="tooltip-right">
                        Edit
                    </Tooltip>
                }
            >
                <button
                    className="child_icon_button pubDraftControls"
                    onClick={() => props.actionPost(post.post_id, 'edit')}
                >
                    <img className="icn" src={editIconUrl} alt="Edit Icon" />
                </button>
            </OverlayTrigger>

        )
    }

    const deleteInfoMeta = () => {
        return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip id="tooltip-right">
                        Delete Post
                    </Tooltip>
                }
            >
                <button
                    className="child_icon_button pubDraftControls"
                    onClick={() => props.actionPost(post.post_id, 'delete')}
                >
                    <img className="icn" src={deleteIconUrl} alt="Delete Icon" />
                </button>
            </OverlayTrigger>
        )
    }

    const postDisplay = (post) => {
        if (post.link) {
            return (
                <div className="child-post-image child-post-image_link">
                    <iframe
                        src={post.link} 
                        frameBorder="0" 
                        allowFullScreen
                    >
                    </iframe>
                </div>
            )
        } else {
            return (
                <div className="child-post-image">
                    <img id="postImage" className="postImage" name="postImage" src={postImageUrl}  alt='Post Image'/>
                </div>
            )
        }
    }

    return(
        <div className="child-post-item">
            <div onClick={() => setIndexFromPost(postIndex)} className="child-post-image-wrap">
                { postDisplay (post) }
            </div>

            {post.document_array[0] !== undefined && <div className="child-post-item-doc">
                <a href={getDocUrl()} target="_blank"> 
                    <img className="child-post-item-doc-icon" src={docUrl} alt="document" />
                </a>
            </div>}

            <div className="child-post-info">
                <div onClick={() => setIndexFromPost(postIndex)} className="child-post-info-header">
                    <h2 className="title">
                        {post.title}
                    </h2>
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip id="tooltip-right">
                                Event date
                            </Tooltip>
                        }
                    >
                        <div className="event-date">
                            {post.event_date}
                            <img className="icn" src={countDownIconUrl} alt="event date" />
                        </div>
                    </OverlayTrigger>
                </div>

                <div className="child-post-info-text">
                    {post.text}
                </div>

                <div className="child-post-info-meta">
                    <div className="meta-inner">
                        <p className="author">
                            {(!props.pubDraft && isFromMe) &&
                                <div>
                                    <img className="icn" src={senderAvatarImageUrl} alt="author_icon"/>
                                    <span>{' ME'}</span>
                                </div>
                            }

                            {(!props.pubDraft && !isFromMe) &&
                                <div>
                                    <img className="icn" src={getPostUserImageUrl()} alt="author_icon" />
                                    <span>{getFromNameToDisplay()}</span>
                                </div>
                            }
                        </p>

                        {(props.pubDraft === "published" || props.pubDraft === "draft" ) &&

                            <p className="role">
                                <span>To: {getToNameToDisplay()}</span>
                            </p>
                        }

                        {props.pubDraft === "incomming" &&
                            <p className="date">
                                <img src={calendar} alt="calender_icon" />
                                {post.date_updated}
                            </p>
                        }

                        {props.pubDraft !== "incomming" &&
                            <p className="date">
                                <img src={calendar} alt="calender_icon" />
                                {post.posted_date}
                            </p>
                        }


                    </div>

                    {props.pubDraft
                        ?
                        props.pubDraft === "published"
                            ?
                            publishedInfoMeta()
                            :
                            draftInfoMeta()
                        :
                        null
                    }

                    {props.pubDraft === "draft" && deleteInfoMeta() }
                </div>

            </div>
        </div>
    )
}

export default ChildPost;